module.exports = __webpack_public_path__ + "void-4c8270c17facce6d53726a2ebb9745f2.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/void.png
// module id = 283
// module chunks = 88